// extracted by mini-css-extract-plugin
module.exports = {"container":"RawHTML_container__7RKla"};